export enum TimeUsuarioStatus {
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO',
  REMOVIDO = 'REMOVIDO'
}
